<div class="d-flex flex-fill flex-column p-2">
  @if (isAdmin) {
    <div class="btn-toolbar mx-0 mt-0 nomination-toolbar">
      <div class="d-flex flex-fill">
        <button class="me-2 btn btn-primary" (click)="printNominationBallot()">Print Ballot</button>
        <button class="me-auto btn btn-danger" (click)="closeAll()">Close All Tallies</button>
      </div>
    </div>
  }

  @if (nominationTallyGroups) {
    <div class="d-flex flex-fill nomination-display">
      <div class="d-flex flex-column p-2">
        <h2 style="text-align: center">Nomination Tally</h2>
        <div class="d-flex flex-fill flex-column">
          @if (true) {
            <div style="max-width: 300px">
              <dx-form class="mb-3" [formData]="filter" [colCount]="3">
                <dxi-item [label]="{ text: 'D' }">
                  <div *dxTemplate>
                    @for (data of deacons; track data) {
                      <div>
                        <dx-number-box [(value)]="data.id"> </dx-number-box>
                      </div>
                    }
                  </div>
                </dxi-item>
                <dxi-item [label]="{ text: 'E' }">
                  <div *dxTemplate>
                    @for (data of execs; track data) {
                      <div>
                        <dx-number-box [(value)]="data.id"> </dx-number-box>
                      </div>
                    }
                  </div>
                </dxi-item>
                <dxi-item [label]="{ text: 'S' }">
                  <div *dxTemplate>
                    @for (data of sheps; track data) {
                      <div>
                        <dx-number-box [(value)]="data.id"> </dx-number-box>
                      </div>
                    }
                  </div>
                </dxi-item>
              </dx-form>
              <button class="mt-3 btn btn-success" (click)="add()" [disabled]="addProcessing">Add Tallies</button>
              <button class="mt-3 ms-2 btn btn-primary" (click)="getData()">Refresh</button>
              <button class="mt-3 ms-2 btn btn-danger" (click)="clear()">Clear</button>
            </div>
          }
          @if (!isAdmin) {
            <div class="mt-4 d-flex phone-display flex-column">
              <div>Last Added Ballot</div>
              @for (data of lastAdded; track data) {
                <div>
                  <div class="d-flex flex-row ms-4">
                    <h3 class="event-date">{{ data }}</h3>
                  </div>
                </div>
              }
            </div>
          }
          @if (isAdmin) {
            <div class="mt-4 d-flex phone-display">
              @for (data of nominationTallyGroups; track data) {
                <div>
                  <div class="d-flex flex-column ms-4">
                    <h3 class="event-date">{{ data.key }}</h3>
                    @for (detail of data.results; track detail) {
                      <div>
                        <div class="mb-2">
                          <h4 class="event-name">{{ detail.nom }} -- {{ detail.count }}</h4>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (isAdmin) {
            <dx-data-grid
              #nominationGrid
              keyExpr="id"
              class="nominations-grids flex-fill"
              [dataSource]="nominationTallies"
              [columnAutoWidth]="false"
              (onToolbarPreparing)="onToolbarPreparing($event)"
              (onSelectionChanged)="onSelectionChange($event)"
              [focusedRowEnabled]="false"
              [showBorders]="true"
              [height]="700"
              >
              <dxi-column dataField="role" caption="Role" width="50"></dxi-column>
              <dxi-column dataField="ballotNumber" caption="No." width="75"></dxi-column>
              <dxi-column dataField="created" caption="Entered" width="100" [sortIndex]="1" [sortOrder]="'desc'" [format]="{ type: 'shortDateShortTime' }"></dxi-column>
              <div *dxTemplate="let data of 'toolbarButtons'">
                @if (isAdmin) {
                  <button class="btn btn-sm btn-primary me-2" (click)="refreshTallies()">Refresh</button>
                }
                @if (isAdmin) {
                  <button class="btn btn-sm btn-danger" (click)="deleteNomination()" [disabled]="nominationGrid.instance.getSelectedRowsData().length !== 1">
                    Delete Ballot Record
                  </button>
                }
              </div>
              <div *dxTemplate="let data of 'toolbarText'">
                @if (nominations) {
                  <span class="me-3"
                    ><strong>{{ nominationGrid.instance.totalCount() + " items" }}</strong></span
                    >
                  }
                </div>
                <dxo-export [enabled]="auth.currentUser?.userName === 'mreimink'"></dxo-export>
                <dxo-selection [mode]="'multiple'"></dxo-selection>
              </dx-data-grid>
            }
          </div>
        </div>
      </div>
    }
  </div>
